import { transition } from '../util';
export default function (element, options) {
    return transition(element, { opacity: 0 }, options);
}
//# sourceMappingURL=fadeOut.js.map